import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import { SessionHelper } from '@/helpers/SessionHelper';
import { AspNetRole, AssociationRoleEnum } from '../models/Enums';
import UserInfo from '../models/api/user/UserInfo';
import setAuthorizationToken from '@/helpers/functions/AxiosToken'
import SnackbarMessage from '../models/SnackbarMessage';

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
    key: 'narvarogo_vuex', // The key to store the state on in the storage provider.
    storage: window.sessionStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    reducer: (state: any) => ({
        sessionModule: state.sessionModule,
        // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
    }),
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
})

const sessionModule = {
    state: () => ({
        userInfo: new UserInfo(),
        currentLanguage: "",
        selectedAssociation: null,
        selectedAssociationName: "",
    }),
    mutations: {
        setSelectedAssociation(state: any, { associationCookie, associationName }: any) {
            state.selectedAssociation = associationCookie;
            state.selectedAssociationName = associationName;
        },
        setCurrentLanguage(state: any, currentLanguage: string) {
            state.currentLanguage = currentLanguage;
        },
        setUserInfo(state: any, userInfo: UserInfo) {
            state.userInfo = userInfo;
            setAuthorizationToken(userInfo.token);
        },
    },
    actions: {},
    getters: {
        selectedAssociation(state: any) {
            return state.selectedAssociation;
        },
        selectedAssociationName(state: any) {
            return state.selectedAssociationName;
        },
        currentLanguage(state: any) {
            return state.currentLanguage;
        },
        userInfo(state: any) {
            return state.userInfo;
        },
        isAuthenticated(state: any) {
            return state.userInfo.isAuthenticated;
        },
        isInRole: (state: any) => (role: AspNetRole) => {
            return state.userInfo.aspNetRole == role;
        },
        isInAssociationRole: (state: any) => (role: AssociationRoleEnum) => {
            return state.userInfo?.associationUserInfo?.role == role;
        },
        isSystemAdmin(state: any, getters: any) {
            return getters.isInRole(AspNetRole.SystemAdmin);
        },
        isMunicipalityAdmin(state: any, getters: any) {
            return getters.isInRole(AspNetRole.MunicipalityAdmin);
        },
        isAssociationUser(state: any, getters: any) {
            return getters.isInRole(AspNetRole.AssociationUser);
        },
        isAssociationUser_GroupAdmin(state: any, getters: any) {
            return getters.isInAssociationRole(AssociationRoleEnum.AssociationGroupAdmin);
        },
        isAssociationUser_Admin(state: any, getters: any) {
            return getters.isInAssociationRole(AssociationRoleEnum.AssociationAdmin);
        },
    }
}

const memoryModule = {
    state: () => ({
        overlayCounter: 0,
        showTabs: false,
        snackbarMessages: [] as SnackbarMessage[],
        resetSnackbar: false,
    }),
    mutations: {
        addSnackbarMessage(state: any, message: SnackbarMessage) {
            state.snackbarMessages.push(message);
        },
        shiftSnackbarMessages(state: any) {
            state.snackbarMessages.shift();
        },
        resetSnackbarMessagesDone(state: any) {
            state.resetSnackbar = false;
        },
        resetSnackbarMessages(state: any) {
            if (state.snackbarMessages.length > 0) {
                state.snackbarMessages = [] as SnackbarMessage[];
                state.resetSnackbar = true;
            }
        },
        addOverlay(state: any) {
            state.overlayCounter++;
        },
        removeOverlay(state: any) {
            state.overlayCounter--;
            if (state.overlayCounter < 0) {
                state.overlayCounter = 0;
            }
        },
        showTabs(state: any) {
            state.showTabs = true;
        },
        hideTabs(state: any) {
            state.showTabs = false;
        },
    },
    actions: {},
    getters: {
        getSnackbarMessagesLength(state: any) {
            return state.snackbarMessages.length;
        },
        getSnackbarMessage(state: any) {
            if (state.snackbarMessages.length > 0) {
                return state.snackbarMessages[0];
            }
            return null;
        },
        overlayCounter(state: any) {
            return state.overlayCounter;
        },
        showTabs(state: any) {
            return state.showTabs
        },
        resetSnackbar(state: any) {
            return state.resetSnackbar;
        }
    }
}

export const store = new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    modules: {
        sessionModule: sessionModule,
        memoryModule: memoryModule
    }
})